import { render } from "./MyReferrals.vue?vue&type=template&id=172834dc&scoped=true"
import script from "./MyReferrals.vue?vue&type=script&lang=js"
export * from "./MyReferrals.vue?vue&type=script&lang=js"

import "./MyReferrals.vue?vue&type=style&index=0&id=172834dc&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172834dc"]])

export default __exports__